import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admin-contracts',
    templateUrl: './admin-contracts.component.html',
    styleUrl: './admin-contracts.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminContractsComponent {

}
